import { egresadosApiCall } from "../../../../axios/apiClient";
import { cmiApiCall } from "../../../../axios/apiClient";

const controller = ``;
const controllerAdmin = `egresados`;

export default {
    getProfileEgresados: async () => {
        let response = { success: true };
        const method = `profile`;
        try {
            const apiResponse = await egresadosApiCall.get(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    validateEgresadoSirExistence: async (data) => {
        let response = { success: true };
        const method = `sir_existe_egresado`;
        try {
            const apiResponse = await egresadosApiCall.post(controller, method, data);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    registerEgresado: async (data) => {
        let response = { success: true };
        const method = `register`;
        try {
            const apiResponse = await egresadosApiCall.post(controller, method, data);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    registerEgresadoMatriculaAntigua: async (data) => {
        let response = { success: true };
        const method = `register-matricula-antigua`;
        try {
            const apiResponse = await egresadosApiCall.post(controller, method, data);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    uploadImageProfile: async (file) => {
        let response = { success: true };
        const method = `upload-image-profile`;
        try {
            const apiResponse = await egresadosApiCall.post(controller, method, file);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    updateInformacion: async (data) => {
        let response = { success: true };
        const method = `update-informacion`;
        try {
            const apiResponse = await egresadosApiCall.put(controller, method, data);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    uploadImageCover: async (file) => {
        let response = { success: true };
        const method = `upload-image-cover`;
        try {
            const apiResponse = await egresadosApiCall.post(controller, method, file);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    getImagen: async (filename) => {
        let response = { success: true };
        const method = `image/${filename}`;
        try {
            const apiResponse = await egresadosApiCall.get(controller, method, { responseType: 'blob' });
            // Convertir blob a URL de navegador
            const imageUrl = URL.createObjectURL(apiResponse.data);
            response.image = imageUrl;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
            response.image = null;
        }
        return response;
    },
    deleteImage: async (tipo_imagen) => {
        let response = { success: true };
        const method = `delete-image/${tipo_imagen}`;
        try {
            const apiResponse = await egresadosApiCall.delete(controller, method);
            response.data = apiResponse?.data;
        } catch (error) {
            response = egresadosApiCall.handleCatch(error);
        }
        return response;
    },
    getCvPdf: async (values) => {
        let response = { success: true };
        const method = `cv-me`;
        try {
            const apiResponse = await egresadosApiCall.post(controller, method, values, { responseType: 'blob' });
            // Convertir blob a URL de navegador
            const cvUrl = URL.createObjectURL(apiResponse.data);
            response.url = cvUrl;
        } catch (error) {
            response = await egresadosApiCall.handleCatchBlob(error);
        }
        return response;
    }, 
    /* Metodos solo para administradores */
    adminUpdateEgresado: async (data) => {
        let response = { success: true };
        const method = `admin-update-egresado`;
        try {
            const apiResponse = await cmiApiCall.put(controllerAdmin, method, data);
            response.message = apiResponse?.data;
        } catch (error) {
            response = cmiApiCall.handleCatch(error);
        }
        return response;
    },
}